var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookingLid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.409,370.168c0-109.597-75.965-214.36-176.965-244.446c2.23-6.615,3.358-13.404,3.358-20.213 c0-35.183-28.622-63.805-63.802-63.805s-63.802,28.622-63.802,63.805c0,6.809,1.128,13.598,3.358,20.213 c-101,30.086-176.963,134.849-176.963,244.446v1.592h474.816V370.168z M158.362,188.059c21.042,0,38.162,17.116,38.162,38.16 c0,21.04-17.12,38.16-38.162,38.16s-38.162-17.12-38.162-38.16C120.2,205.175,137.32,188.059,158.362,188.059z M256,76.689 c15.893,0,28.822,12.927,28.822,28.82c0,4.433-1.089,8.792-3.24,12.97c-8.702-1.075-17.302-1.619-25.582-1.619 c-8.28,0-16.881,0.544-25.582,1.619c-2.15-4.177-3.24-8.536-3.24-12.97C227.178,89.616,240.107,76.689,256,76.689z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484.488,403.51H27.514C12.343,403.51,0,415.851,0,431.022v30.276c0,4.961,4.035,8.998,8.996,8.998h494.009 c4.959,0,8.994-4.037,8.994-8.998v-30.276C512,415.851,499.659,403.51,484.488,403.51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingLid);
export default __webpack_public_path__ + "static/media/cooking-lid.7272373b50cda320ef6b75bf8fdb3e8a.svg";
export { ForwardRef as ReactComponent };